export default "__VITE_ASSET__75cbe503__"